import { PharmaStpFileModel } from "../../../../data-model/nycbsPharmaOrder";
import { TableCellMultiline } from "../../../../data-model/tableCells";
import { OrganizationType } from "../../../../enums/organizationTypes";
import { formatTimestampToDisplay } from "../../../pharmaOncologyAppeals/table/utils/formatDobToDisplay";
import {
  extractBatchFromFileName,
  extractFormattedDateFromFileName,
} from "./extractDateFromFileName";

/**
 * Builds the DOW cell for a calling worklist row.
 *
 * Astera orders come in from CoverMyMeds rather than a batch CSV, so their
 * filename carries neither a date nor a batch - `dumped_at` is the only date of
 * work available. Every other org keeps the filename-derived date and batch.
 *
 * @param item - Raw calling worklist order row
 * @param orgId - Currently selected organization / facility id
 * @returns Multiline cell with the date of work and, when available, the batch.
 *          Astera rows hide the copy icon because there is no batch subtitle.
 */
export const buildDowCell = (
  item: PharmaStpFileModel,
  orgId: string,
): TableCellMultiline => {
  if (orgId === OrganizationType.ASTERA) {
    return {
      mainText: formatTimestampToDisplay(item?.dumped_at),
      hideCopyIcon: true,
    };
  }

  const fileName: string = item?.filename ?? "";
  return {
    mainText: extractFormattedDateFromFileName(fileName),
    secondaryText: `Batch : ${extractBatchFromFileName(fileName)}`,
  };
};
